<template>
  <div class="bud">
    <div class="bud__top-banner">
      <picture>
        <source
          :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/banner_mob.jpg`"
          media="(max-width: 767px)"
        />
        <source
          :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/banner.jpg`"
          media="(min-width: 1220px)"
        />
        <img
          class="bud__top-banner-img"
          :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/banner.jpg`"
        />
      </picture>
      <div class="bud__top-banner-content">
        <div class="content">
          <div class="bud__top-banner-title">
            Почка <br />
            за почкой
          </div>
          <div class="bud__top-banner-description">
            Ваш шанс задать вопрос эксперту!
          </div>
          <a
            href="#form"
            class="bud__top-banner-button button button_white-blue"
            >Задать вопрос</a
          >
        </div>
      </div>
    </div>
    <div class="bud__page">
      <div class="content">
        <div class="bud__sections">
          <div class="bud__section bud__section-1">
            <img
              class="bud__section-img"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/section1.jpg`"
            />
            <div class="bud__section-title">ХБП - «призрак»:<sup>1-5</sup></div>
          </div>
          <div class="bud__section bud__section-2">
            <img
              class="bud__section-img"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/section2.jpg`"
            />
            <div class="bud__section-title">Дополнительная сложность</div>
            <div class="bud__section-description">
              ХБП на ранних стадиях протекает бессимптомно
            </div>
          </div>
          <div class="bud__section bud__section-3">
            <picture>
              <source
                :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/section3_mob.jpg`"
                media="(max-width: 767px)"
              />
              <source
                :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/section3_tab.jpg`"
                media="(max-width: 1220px)"
              />
              <img
                class="bud__section-img"
                :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/section3.jpg`"
              />
            </picture>
            <div class="bud__section-text">
              <div class="bud__section-title">
                Диагностические и терапевтические аспекты
              </div>
              <div class="bud__section-description">
                остаются объектом дальнейшего изучения
              </div>
            </div>
          </div>
          <div class="bud__section bud__section-4">
            <div class="bud__section-row">
              <div class="bud__section-icon">
                <img
                  :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/section4.png`"
                />
              </div>
              <div class="bud__section-text">
                <div class="bud__section-title">
                  Болезнь словно потерялась среди врачей
                </div>
                <div class="bud__section-description">
                  неврологами, терапевтами, эндокринологами, кардиологами.
                  <br />
                  <br />
                  Пациенты остаются наедине с болезнью, которая не
                  контролируется в полной мере.
                </div>
              </div>
            </div>
          </div>
          <div class="bud__section bud__section-5">
            <img
              class="bud__section-img"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/section5.jpg`"
            />
            <div class="bud__section-title">
              Болезнь привычная, но размытая между специалистами
            </div>
          </div>
        </div>
        <div class="bud__question">
          <div class="bud__question-tag">Пора развеять мифы!</div>
          <div class="bud__question-title">
            Задайте вопрос профессору <br />Наталье Андреевне Козиоловой
          </div>
          <div class="bud__question-description">
            Узнайте то, что может спасти жизнь пациента
          </div>
          <a href="#form" class="bud__question-button button button_white-blue">
            Задать вопрос
          </a>
        </div>
        <div class="bud__speaker">
          <div class="bud__speaker-img">
            <img
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/speaker.jpg`"
            />
          </div>
          <div class="bud__speaker-text">
            <div class="bud__speaker-tag">Профессор</div>
            <div class="bud__speaker-name">Козиолова Наталья Андреевна</div>
            <div class="bud__speaker-position">
              Ведущий эксперт в лечении ХБП
            </div>
            <div class="bud__speaker-description">
              Член Президиума Правления Российского кардиологического общества,
              Президент Пермского краевого кардиологического общества,
              Заведующая кафедрой внутренних болезней и кардиологии Пермского
              государственного медицинского университета им. академика Е.А.
              Вагнера
            </div>
          </div>
        </div>
        <div class="bud__form" id="form">
          <div class="bud__form-icon">
            <img
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/form__icon.png 2x`"
            />
          </div>
          <div class="bud__form-title">
            Ни один вопрос не останется без ответа!
          </div>
          <div class="bud__form-form" v-show="!formSended">
            <input
              :class="{
                'bud__form-input_fill': name.value,
                'bud__form-input_error': name.isError,
              }"
              class="bud__form-input"
              type="text"
              v-model="name.value"
              placeholder="Как к Вам можно обращаться? *"
            />
            <input
              :class="{
                'bud__form-input_fill': email.value,
                'bud__form-input_error': email.isError,
              }"
              class="bud__form-input"
              type="email"
              v-model="email.value"
              placeholder="Укажите адрес Вашей электронный почты для обратной связи *"
            />
            <textarea
              :class="{
                'bud__form-input_fill': question.value,
                'bud__form-input_error': question.isError,
              }"
              class="bud__form-input bud__form-textarea"
              v-model="question.value"
              placeholder="Введите Ваш вопрос связанный с диагностикой и терапией ХБП? *"
            ></textarea>
            <label
              class="bud__form-checkbox"
              :class="{ 'bud__form-checkbox_error': pd.isError }"
            >
              <div class="bud__form-checkbox-input">
                <input type="checkbox" v-model="pd.value" />
                <svg
                  width="17"
                  height="13"
                  viewBox="0 0 17 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.87303 13L0 6.82544L1.23818 5.52369L5.87303 10.3965L15.7618 0L17 1.30175L5.87303 13Z"
                    fill="#095092"
                  />
                </svg>
              </div>
              <div class="bud__form-checkbox-label">
                Я даю свое согласие на обработку персональных данных *
              </div>
            </label>
            <label
              class="bud__form-checkbox"
              :class="{ 'bud__form-checkbox_error': notify.isError }"
            >
              <div class="bud__form-checkbox-input">
                <input type="checkbox" v-model="notify.value" />
                <svg
                  width="17"
                  height="13"
                  viewBox="0 0 17 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.87303 13L0 6.82544L1.23818 5.52369L5.87303 10.3965L15.7618 0L17 1.30175L5.87303 13Z"
                    fill="#095092"
                  />
                </svg>
              </div>
              <div class="bud__form-checkbox-label">
                Я даю свое согласие на получение email-сообщения от «АстраЗенека
                Фармасьютикалз» *
              </div>
            </label>
            <div class="bud__form-description">
              Если вы хотите сообщить о претензии в отношении качества или
              подлинности лекарственного препарата, вы можете обратиться в ООО
              «АстраЗенека Фармасьютикалз»: Сделать это вы можете
              по телефону: +7 (495) 799-56-99 Или по электронной
              почте: ProductQuality.ru@astrazeneca.com Если вас интересует
              медицинская и научная информация о препаратах компании, вы можете
              отправить запрос на её получение с помощью электронной
              почты Medinfo.ru@astrazeneca.com или по телефону +7 (495)
              799-56-99
              <br />
              «Если вам стало известно о нежелательном явлении, возникшем при
              применении лекарственного препарата компании «АстраЗенека»,
              пожалуйста, сообщите нам по электронной
              почте Safety.Russia@astrazeneca.com или по телефону  +7 (495)
              799-56-99».
            </div>
            <div
              class="bud__form-button button button_white-blue"
              @click="send"
            >
              Отправить
            </div>
          </div>
          <div class="bud__form-final" v-show="formSended">
            <div class="bud__form-final-block">
              <div class="bud__form-final-block-text" v-show="!eventDate">
                Спасибо за Ваш вопрос! <br />
                Ожидайте от нас письмо с информацией о прямом эфире <br />
                с экспертом и ответом на Ваш вопрос.
              </div>
              <div class="bud__form-final-block-timer" v-show="eventDate">
                <div
                  class="bud__form-final-block-timer-title"
                  :class="{
                    'bud__form-final-block-timer-title_broadcast': timerResult,
                  }"
                >
                  {{
                    timerResult
                      ? "Прямой эфир с экспертным разбором вопросов начнется через:"
                      : "Идет прямая трансляция с экспертным разбором вопросов"
                  }}
                </div>

                <div class="bud__form-final-block-timer-row" v-if="timerResult">
                  <div class="bud__form-final-block-timer-item">
                    <div class="bud__form-final-block-timer-item-value">
                      {{ timerResult.hours }}
                    </div>
                    <div class="bud__form-final-block-timer-item-label">
                      {{
                        helpers.getNoun(
                          timerResult.hours,
                          "час",
                          "часа",
                          "часов"
                        )
                      }}
                    </div>
                  </div>
                  <div class="bud__form-final-block-timer-item">
                    <div class="bud__form-final-block-timer-item-value">
                      {{ timerResult.minutes }}
                    </div>
                    <div class="bud__form-final-block-timer-item-label">
                      {{
                        helpers.getNoun(
                          timerResult.minutes,
                          "минуту",
                          "минуты",
                          "минут"
                        )
                      }}
                    </div>
                  </div>
                  <div class="bud__form-final-block-timer-item">
                    <div class="bud__form-final-block-timer-item-value">
                      {{ timerResult.seconds }}
                    </div>
                    <div class="bud__form-final-block-timer-item-label">
                      {{
                        helpers.getNoun(
                          timerResult.seconds,
                          "секунду",
                          "секунды",
                          "секунд"
                        )
                      }}
                    </div>
                  </div>
                </div>
                <div
                  v-if="!timerResult"
                  class="bud__form-final-block-timer-button button button_blue-white"
                >
                  Подключиться
                </div>
              </div>
            </div>
            <div class="bud__form-final-description" v-show="!isAuth">
              <a :href="$root.ssoLinks.login">Авторизуйтесь</a> /
              <a :href="$root.ssoLinks.registration">Зарегистрируйтесь</a>,
              чтобы не пропустить ответ эксперта на Ваш вопрос
            </div>
            <div
              @click="repeatForm"
              class="bud__form-final-button button button_white-blue"
            >
              Задать новый вопрос
            </div>
          </div>
        </div>
        <div class="bud__footer">
          <div class="bud__footer-glass-block">
            <div class="bud__footer-glass-block-title">
              KDIGO 2024<sup>5</sup>
            </div>
            <div class="bud__footer-glass-block-description">
              иНГЛТ-2 рекомендованы для терапии взрослых пациентов с ХБП при
              наличии:
            </div>
          </div>
          <div class="bud__footer-row">
            <div class="bud__footer-item">
              рСКФ ≥ 20 мл/мин/1,73 м² и отношением А/Кр мочи ≥ 200 мг/г (1А)
            </div>
            <div class="bud__footer-item">
              рСКФ 20-45 мл/мин/1,73 м² и отношением А/Кр мочи &lt; 200 мг/г
              (2B)
            </div>
          </div>
          <img
            class="bud__footer-img"
            :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/footer.jpg 2x`"
          />
        </div>
      </div>
      <div class="bud__sources">
        <div class="content">
          <hr />
          <div class="bud__sources-title">Список литературы: </div>
          <ol class="bud__sources-list">
            <li>
              Клинические рекомендации Хроническая болезнь почек, 2024
              <a
                href="https://cr.minzdrav.gov.ru/recomend/469_3"
                target="_blank"
                >https://cr.minzdrav.gov.ru/recomend/469_3</a
              >
              дата обращения 05.05.2025;
            </li>
            <li>Sundström J, et al. Lancet Reg Health Eur2022;20:100438; </li>
            <li>Tangri N, et al. AdvTher2023;40:2869–2885; </li>
            <li>Tangri N, et al. BMJ Open 2023;13:e067386; </li>
            <li>KDIGO CKD Work Group. Kidney Int. 2024;105(4S):S117–S314.</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "BudByBud",
  data: () => ({
    name: {
      isError: false,
      value: "",
    },
    email: {
      isError: false,
      value: "",
    },
    question: {
      isError: false,
      value: "",
    },
    pd: {
      isError: false,
      value: false,
    },
    notify: {
      isError: false,
      value: false,
    },
    formSended: false,
    eventDate: null, // вставить дату мероприятия для вывода таймера. формат: 2023-09-19T17:19:05+03:00
    timerResult: null,
  }),
  computed: {
    ...mapGetters(["isAuth", "user"]),
  },
  methods: {
    send() {
      let error = false;
      if (!this.name.value.replace(/ /g, "")) {
        this.setFieldStatus(this.name);
        error = true;
      }
      if (
        !this.email.value.replace(/ /g, "") ||
        !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/g.test(this.email.value)
      ) {
        this.setFieldStatus(this.email);
        error = true;
      }
      if (!this.question.value.replace(/ /g, "")) {
        this.setFieldStatus(this.question);
        error = true;
      }
      if (!this.pd.value) {
        this.setFieldStatus(this.pd);
        error = true;
      }
      if (!this.notify.value) {
        this.setFieldStatus(this.notify);
        error = true;
      }
      if (error) return;
      this.$axios(`/api/expert-question/`, {
        method: "POST",
        data: {
          appeal: this.name.value,
          email: this.email.value,
          text: this.question.value,
          is_agree_to_use_of_personal_data: this.pd.value,
          is_agree_to_get_answer: this.notify.value,
        },
      }).finally(() => {
        this.$nextTick(() => {
          this.formSended = true;
          document
            .querySelector(".bud__form")
            .scrollIntoView({ block: "center" });
        });
      });
    },
    repeatForm() {
      this.name.value = "";
      this.email.value = "";
      this.question.value = "";
      this.pd.value = false;
      this.notify.value = false;
      this.formSended = false;
    },
    setFieldStatus(f, e = true, time = 2000) {
      this.$set(f, "isError", e);
      setTimeout(() => {
        this.$set(f, "isError", false);
      }, time);
    },
    timer() {
      let date = new Date();
      const dateEnd = new Date(this.eventDate);
      const diff = date.getTime() / 1000 - dateEnd.getTime() / 1000;
      this.$set(this, "timerResult", null);
      if (diff > 0) return;
      this.$set(this, "timerResult", {});
      let months = Math.abs(diff) / 2592000;
      let fullMonths = Math.floor(months);
      let days = (months - Math.floor(months)) * 30;
      let fullDays = Math.floor(days);
      let hours = (days - Math.floor(days)) * 24;
      let fullHours = Math.floor(hours);
      let minutes = (hours - Math.floor(hours)) * 60;
      let fullMinutes = Math.floor(minutes);
      let seconds = (minutes - Math.floor(minutes)) * 60;
      let fullSeconds = Math.round(seconds);
      this.$set(this, "timerResult", {});
      if (fullMonths) {
        this.$set(this.timerResult, "months", fullMonths);
      }
      if (fullDays) {
        this.$set(this.timerResult, "days", fullDays);
      }
      if (fullHours) {
        this.$set(this.timerResult, "hours", fullHours);
      }
      if (fullMinutes) {
        this.$set(this.timerResult, "minutes", fullMinutes);
      }
      if (fullSeconds) {
        this.$set(this.timerResult, "seconds", fullSeconds);
      }
    },
  },
  mounted() {
    this.timer();
    this.interval = setInterval(this.timer, 1000);
    if (this.isAuth) {
      this.name.value = this.user.first_name;
      this.email.value = this.user.email;
    }
  },
};
</script>

<style lang="scss" scoped>
.bud {
  background-color: #c0dfff;

  & .content {
    @media screen and (max-width: 1220px) {
      padding: 0 16px;
    }
  }

  &__top-banner {
    position: relative;
    &-img {
      width: 100%;
      height: auto;
      object-fit: contain;
    }

    &-content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
    }

    & .content {
      display: flex;
      flex-direction: column;
      height: 100%;
      @media screen and (max-width: 1220px) {
        padding: 0 16px;
      }
    }

    &-title {
      margin-top: auto;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 80px;
      line-height: 80px;
      color: #ffffff;

      @media screen and (max-width: 1220px) {
        font-size: 42px;
        line-height: 42px;
      }

      @media screen and (max-width: 767px) {
        margin-top: 40px;
        text-align: center;
      }
    }

    &-description {
      margin-bottom: 20px;
      margin-top: 80px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 28px;
      color: #ffffff;

      @media screen and (max-width: 1220px) {
        font-size: 18px;
        line-height: 18px;
      }

      @media screen and (max-width: 767px) {
        margin: 40px auto 20px;
        max-width: 50%;
        font-size: 20px;
        line-height: 24px;
        text-align: center;
      }
    }

    &-button {
      margin-bottom: auto;
      font-size: 22px;
      padding: 16px 32px;

      @media screen and (max-width: 1220px) {
        font-size: 18px;
        line-height: 18px;
      }
    }
  }

  &__page {
    overflow: hidden;
  }

  &__sections {
    padding: 120px 0;
    display: grid;
    grid-template-areas:
      "s1 s1 s1 s1 s2 s2 s2 s2 s3 s3 s3 s3"
      "s4 s4 s4 s4 s4 s5 s5 s5 s3 s3 s3 s3";
    gap: 40px;
    @media screen and (max-width: 1220px) {
      padding: 80px 0;
      gap: 20px;
      grid-template-areas:
        "s1 s1 s1 s1 s2 s2 s2 s2"
        "s3 s3 s3 s3 s3 s3 s3 s3"
        "s4 s4 s4 s4 s4 s5 s5 s5";
    }

    @media screen and (max-width: 767px) {
      padding: 40px 0;
      gap: 4px;
      grid-template-areas:
        "s1 s1 s1 s1"
        "s2 s2 s5 s5"
        "s3 s3 s3 s3"
        "s4 s4 s4 s4";
    }
  }

  &__section {
    border-radius: 20px;
    overflow: hidden;
    position: relative;
    min-height: 300px;
    padding: 30px;
    @media screen and (max-width: 767px) {
      padding: 20px;
      min-height: 200px;
    }

    &-img {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      object-fit: contain;
      object-position: center bottom;
      display: block;

      @media screen and (max-width: 1220px) {
        object-fit: cover;
      }
    }

    &-title {
      position: relative;
      z-index: 2;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 22px;
      color: #1f1f1f;

      @media screen and (max-width: 1220px) {
        font-size: 18px;
      }
      @media screen and (max-width: 767px) {
        font-size: 16px;
      }
    }

    &-description {
      position: relative;
      z-index: 2;
      margin-top: 16px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 21px;
      color: #1f1f1f;

      @media screen and (max-width: 1220px) {
        font-size: 16px;
      }
      @media screen and (max-width: 767px) {
        margin-top: 8px;
      }
    }

    &-1 {
      grid-area: s1;
      background-color: #69aff7;

      & .bud__section-title {
        font-family: "Roboto Slab", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 43px;
        line-height: 48px;
        text-align: center;
        color: #ffffff;

        @media screen and (max-width: 1220px) {
          font-size: 32px;
          line-height: 42px;
        }

        @media screen and (max-width: 767px) {
        }
      }
    }

    &-2 {
      grid-area: s2;
      background-color: #ebf6ff;
      @media screen and (max-width: 767px) {
        padding: 10px;
      }

      & .bud__section-img {
        object-fit: cover;
      }
    }

    &-3 {
      grid-area: s3;
      background: linear-gradient(180deg, #a2ceff 0%, #c7e7ff 72.17%);
      display: flex;
      flex-direction: column;

      @media screen and (max-width: 1220px) {
        min-height: auto;
        align-items: flex-end;
      }

      @media screen and (max-width: 767px) {
        height: 320px;
        background-color: #a2ceff;
      }

      & .bud__section-text {
        margin-top: auto;
        @media screen and (max-width: 1220px) {
          max-width: 49%;
        }
        @media screen and (max-width: 767px) {
          max-width: none;
        }
      }

      & .bud__section-img {
        object-fit: cover;
        @media screen and (max-width: 1220px) {
          object-position: left center;
        }
      }
    }

    &-4 {
      grid-area: s4;
      background-color: #ebf6ff;

      & .bud__section-row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 32px;
        @media screen and (max-width: 1220px) {
          gap: 16px;
        }
        @media screen and (max-width: 767px) {
          flex-direction: column;
        }
      }

      & .bud__section-icon {
        width: 30%;
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        & img {
          width: 100%;
        }
      }
    }

    &-5 {
      grid-area: s5;
      background-color: #ebf6ff;

      @media screen and (max-width: 767px) {
        padding: 10px;
      }
    }
  }

  &__question {
    background-image: url("https://storage.yandexcloud.net/" + $VUE_APP_BACKET_NAME + "/media/content/public/assets/img/bud/glass.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 20px;
    overflow: hidden;
    padding: 60px 0;
    @media screen and (max-width: 767px) {
      padding: 40px 16px;
    }

    &-tag {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 99px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      color: #ffffff;
      width: fit-content;
      padding: 16px 32px;
      background-color: #4ca8e4;
      margin: 0 auto 40px;
      @media screen and (max-width: 1220px) {
        font-size: 14px;
        padding: 8px 16px;
        margin-bottom: 24px;
      }
    }

    &-title {
      margin-bottom: 32px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 52px;
      line-height: 69px;
      text-align: center;
      color: #095092;
      @media screen and (max-width: 1220px) {
        font-size: 32px;
        line-height: 32px;
      }
      @media screen and (max-width: 767px) {
        font-size: 28px;
      }
    }

    &-description {
      margin-bottom: 40px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 28px;
      text-align: center;
      color: #3278ba;

      @media screen and (max-width: 1220px) {
        font-size: 16px;
        line-height: 20px;
      }
    }

    &-button {
      margin: 0 auto;
      font-size: 32px;
      padding: 16px 32px;

      @media screen and (max-width: 1220px) {
        font-size: 18px;
        line-height: 20px;
      }
    }
  }

  &__speaker {
    margin: 80px 0;
    border-radius: 20px;
    overflow: hidden;
    background-color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 20px 60px 60px;
    gap: 60px;
    @media screen and (max-width: 1220px) {
      padding: 20px 30px 30px;
      gap: 32px;
    }
    @media screen and (max-width: 767px) {
      flex-direction: column;
    }

    &-text {
      margin: auto 0;
    }

    &-img {
      width: 30%;
      flex-shrink: 0;
      border-radius: 20px;
      overflow: hidden;
      @media screen and (max-width: 767px) {
        width: 100%;
      }

      & img {
        width: 100%;
      }
    }

    &-tag {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 99px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 20px;
      color: #ffffff;
      width: fit-content;
      padding: 16px 32px;
      background-color: #4ca8e4;
      margin: 0 0 32px;
      @media screen and (max-width: 1220px) {
        font-size: 14px;
        padding: 8px 16px;
        margin-bottom: 24px;
      }
    }

    &-name {
      margin-bottom: 32px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 42px;
      line-height: 55px;
      color: #095092;
      @media screen and (max-width: 1220px) {
        font-size: 22px;
        line-height: 22px;
      }
    }

    &-position {
      margin-bottom: 16px;
      font-family: "Roboto";
      font-style: normal;
      font-weight: 400;
      font-size: 26px;
      line-height: 31px;
      color: #4ca8e4;

      @media screen and (max-width: 1220px) {
        font-size: 16px;
        line-height: 20px;
      }
    }

    &-description {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 21px;
      color: #101828;

      @media screen and (max-width: 1220px) {
        font-size: 16px;
        line-height: 20px;
      }
    }
  }

  &__form {
    margin: 80px auto;
    max-width: 900px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    @media screen and (max-width: 1220px) {
      max-width: 500px;
      margin: 40px auto;
    }

    @media screen and (max-width: 767px) {
      width: 100%;
    }

    &-icon {
      margin-bottom: 32px;
      @media screen and (max-width: 1220px) {
        width: 100px;
      }

      & img {
        width: 100%;
      }
    }

    &-title {
      margin-bottom: 32px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 42px;
      line-height: 44px;
      text-align: center;
      color: #095092;
      @media screen and (max-width: 1220px) {
        font-size: 24px;
        line-height: 28px;
      }
    }

    &-form {
      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }

    &-input {
      display: block;
      width: 100%;
      height: 80px;
      padding: 30px 20px;
      border-radius: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      background-color: #fff;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 23px;
      color: #000000;
      border: 1px solid #fff;
      margin-bottom: 32px;
      @media screen and (max-width: 1220px) {
        font-size: 16px;
      }

      &::placeholder {
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        color: #868b95;
        @media screen and (max-width: 1220px) {
          font-size: 14px;
        }
      }

      &_fill {
        border-color: #095092;
      }

      &_error {
        border-color: red;
        &::placeholder {
          color: red;
        }
      }
    }

    &-textarea {
      height: 160px;
      resize: none;
    }

    &-checkbox {
      margin-bottom: 16px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      align-self: flex-start;
      gap: 12px;
      cursor: pointer;

      &_error {
        & .bud__form-checkbox-label {
          color: red;
        }
      }

      &-input {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        border-radius: 4px;
        background-color: #fff;
        border: 1px solid #8dc6f7;
        display: flex;
        justify-content: center;
        align-items: center;

        & > svg {
          width: 80%;
          height: auto;
          transition: 0.3s;
          opacity: 0;
        }

        & input {
          display: none;

          &:checked {
            & ~ * {
              opacity: 1;
            }
          }
        }
      }

      &-label {
        margin: auto 0;
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        color: #38658f;
      }
    }

    &-description {
      margin: 16px 0;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      color: #4c779f;

      @media screen and (max-width: 1220px) {
        font-size: 16px;
        line-height: 18px;
      }
    }

    &-button {
      margin: 0 auto;
      font-size: 22px;
      padding: 16px 32px;

      @media screen and (max-width: 1220px) {
        font-size: 18px;
        line-height: 20px;
      }
    }

    &-final {
      width: 100%;
      &-block {
        padding: 30px 20px;
        background-color: #fff;
        border: 1px solid #095092;
        border-radius: 20px;
        overflow: hidden;
        width: 100%;

        &-text {
          font-family: "Roboto", sans-serif;
          font-style: normal;
          font-weight: 400;
          font-size: 22px;
          line-height: 26px;
          text-align: center;
          color: #000000;

          @media screen and (max-width: 1220px) {
            font-size: 16px;
            line-height: 18px;
          }
        }

        &-timer {
          &-title {
            font-family: "Roboto", sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 22px;
            line-height: 26px;
            text-align: center;
            color: #000000;

            &::before {
              width: 16px;
              height: 16px;
              border-radius: 50%;
              background-color: red;
              animation: blink 0.5s linear infinite backwards alternate;
              display: inline-block;
              content: "";
              flex-shrink: 0;
            }
          }

          @keyframes blink {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }

          &-row {
            margin-top: 16px;
            display: grid;
            grid-template-columns: repeat(3, auto);
            justify-content: center;
            gap: 32px;
          }

          &-button {
            margin: 32px auto 0;
            font-size: 22px;
            padding: 16px 32px;

            @media screen and (max-width: 1220px) {
              font-size: 18px;
              line-height: 20px;
            }
          }

          &-item {
            position: relative;
            &:last-child {
              &::before {
                display: none;
              }
            }
            &::before {
              width: 2px;
              height: 30px;
              background-color: #3278ba52;
              position: absolute;
              right: -16px;
              top: 50%;
              transform: translateY(-50%);
              display: block;
              content: "";
            }

            &-value {
              font-family: "Roboto Slab", sans-serif;
              font-style: normal;
              font-weight: 400;
              font-size: 42px;
              text-align: center;
              color: #3278ba;
            }

            &-label {
              font-family: "Roboto", sans-serif;
              font-style: normal;
              font-weight: 400;
              font-size: 20px;
              line-height: 23px;
              text-align: center;
              color: #4c779f;
            }
          }
        }
      }

      &-description {
        margin: 32px 0;
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
        text-align: center;
        color: #4c779f;

        @media screen and (max-width: 1220px) {
          font-size: 16px;
          line-height: 18px;
        }

        & a {
          text-decoration-line: underline;
        }
      }

      &-button {
        margin: 32px auto 0;
        font-size: 22px;
        padding: 16px 32px;

        @media screen and (max-width: 1220px) {
          font-size: 18px;
          line-height: 20px;
        }
      }
    }
  }

  &__footer {
    &-glass-block {
      width: 100%;
      background-image: url("https://storage.yandexcloud.net/" + $VUE_APP_BACKET_NAME + "/media/content/public/assets/img/bud/glass.jpg");
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 20px;
      overflow: hidden;
      padding: 32px 80px;

      &-title {
        margin-bottom: 12px;
        font-family: "Roboto Slab", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 42px;
        line-height: 55px;
        text-align: center;
        color: #095092;

        @media screen and (max-width: 1220px) {
          font-size: 24px;
          line-height: 28px;
        }
      }

      &-description {
        max-width: 60%;
        margin: 0 auto;
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 32px;
        line-height: 38px;
        text-align: center;
        color: #095092;

        @media screen and (max-width: 1220px) {
          font-size: 16px;
          line-height: 24px;
          max-width: none;
        }
      }
    }

    &-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 40px;
      margin-top: 40px;
      @media screen and (max-width: 1220px) {
        gap: 20px;
        margin-top: 20px;
      }
      @media screen and (max-width: 767px) {
        grid-template-columns: 1fr;
      }
    }

    &-item {
      border-radius: 20px;
      overflow: hidden;
      padding: 40px 80px;
      background-color: #fff;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 26px;
      line-height: 31px;
      color: #287dca;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      gap: 12px;

      @media screen and (max-width: 1220px) {
        padding: 20px 40px;
        font-size: 16px;
        line-height: 24px;
        max-width: none;
      }

      &::before {
        content: "·";
        font-size: 50px;
        color: inherit;
        flex-shrink: 0;
      }
    }

    &-img {
      margin: 0 auto;
      max-width: 100%;
    }
  }

  &__sources {
    padding: 32px 0 0;
    background-color: #88c3f7;
    backdrop-filter: blur(6px);
    box-shadow: 0 0 70px 55px #88c3f7;

    & hr {
      color: #fff;
    }

    &-title {
      margin-top: 16px;
      margin-bottom: 16px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 31px;
      color: #ffffff;
      @media screen and (max-width: 767px) {
        font-size: 18px;
        line-height: 24px;
      }
    }

    &-list {
      list-style-type: decimal;
      margin-left: 1em;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 21px;
      color: #f0f0f0;
      @media screen and (max-width: 767px) {
        font-size: 16px;
        line-height: 21px;
      }
      & li {
        &:not(:last-child) {
          margin-bottom: 8px;
          @media screen and (max-width: 767px) {
            margin-bottom: 4px;
          }
        }
      }
    }
  }

  & .button {
    &_white-blue {
      color: #3278ba;
      background-color: #fff;

      &:hover {
        color: #fff;
        background-color: #4ca8e4;
      }
    }

    &_blue-white {
      color: #fff;
      background-color: #3278ba;
      border: 1px solid #3278ba;

      &:hover {
        color: #3278ba;
        background-color: #fff;
      }
    }
  }

  & sup {
    vertical-align: super;
    font-family: inherit;
    font-style: normal;
    font-weight: inherit;
    font-size: 65%;
    line-height: 1;
    color: currentColor;
    white-space: nowrap;
  }
}
</style>

<style lang="scss">
.bud ~ .bottom-tip {
  background-color: #88c3f7;
  color: #fff !important;
  margin: 0 !important;
  padding: 32px 0;

  & .content {
    @media screen and (max-width: 1220px) {
      padding: 0 16px;
    }
  }
}
</style>